import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";

export default function ListSelect(props) {
	return (
		<TextField
			select
			required={props.required}
			size={props.size}
			disabled={props.disabled}
			className={props.className}
			error={props.error}
			value={props.value || ""}
			name={props.name}
			label={props.label}
			multiple={props.multiple}
			onChange={props.onChange}
			variant={props.variant ? props.variant : "outlined"}
			sx={{
				width: props.width ? props.width : "100%",
				marginBottom: props.marginBottom ? props.marginBottom : "20px",
				marginTop: props.marginTop ? props.marginTop : "0px",
				marginX: 0,
				bgcolor: "white",
				
			}}
			slotProps={{
				select: {
					multiple: props.multiple,
					value: props.value || "",
					onChange: props.onChange,
				},
				TextField: {
					sx: {
						backgroundColor: "white",
						m: 0,
						height: props.height ? props.height : "30px",
					},
				},
			}}
		>
			{props.list?.length > 0 ? (
				props.list.map((option) => (
					<MenuItem key={option} value={option}>
						{option}
					</MenuItem>
				))
			) : (
				<MenuItem key="1" value={""}></MenuItem>
			)}
		</TextField>
	);
}
